import React from 'react';
import { Redirect, Route, useLocation, useRouteMatch } from 'react-router-dom';
import { NewLongSteelOrders } from './NewLongSteelOrders';
import { OrderDetail } from './OrderDetail';

import LoadingModal from '../../../components/LoadingModal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { OrderCancel } from './OrderCancel';
import { OrderDownload } from './OrderDownload';
import { OrderUpdate } from './OrderUpdate';
import { UpateItemsUnavailable } from './ModalsOrder';
import { sendTagging } from '../../../store/ducks/tagging/actions';

export enum ENewLongSteelOrdersRoutes {
  ORDERS = '/',
  DETAILS = '/details',
  UPDATE = '/update'
}

export const LongSteelOrdersRoutes3: React.FC = () => {
  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const { pathname } = useLocation();

  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );

  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const loadingState =
    customersState.loading ||
    ordersState.loading ||
    ordersState.updateItems.loading.exportOrders ||
    ordersState.updateItems.loading.downloadOrders ||
    ordersState.updateItems.loading.cancelOrders ||
    ordersState.updateItems.loading.repeatOrders ||
    ordersState.updateItems.loading.validationOrders;

  const loadMessage = () => {
    if (ordersState.loading) {
      return 'Buscando os seus pedidos...';
    }

    if (ordersState.updateItems.loading.exportOrders) {
      return 'Exportando todos os seus pedidos...';
    }

    if (ordersState.updateItems.loading.downloadOrders) {
      return 'Baixando o documento...';
    }

    if (ordersState.updateItems.loading.cancelOrders) {
      return 'Efetuando sua solicitação...';
    }

    return 'Carregando os dados ...';
  };

  React.useEffect(() => {
    (() => window.scrollTo({ top: 0, behavior: 'smooth' }))();
  }, [pathname]);

  React.useEffect(() => {
    dispatch(
      sendTagging({
        event: 'tipo_experiencia',
        screenName: 'LG:MeusPedidos',
        versao_experiencia: 'nova',
        origem_troca: 'antiga'
      })
    );
  }, [dispatch]);

  return (
    <>
      <Route exact path={`${path}`} component={NewLongSteelOrders} />

      <Route
        exact
        path={`${path}${ENewLongSteelOrdersRoutes.DETAILS}`}
        component={OrderDetail}
      >
        <Redirect to={`${path}${ENewLongSteelOrdersRoutes.ORDERS}`} />
      </Route>

      <Route
        exact
        path={`${path}${ENewLongSteelOrdersRoutes.DETAILS}/:orderId`}
        component={OrderDetail}
      />

      <Route
        path={`${path}${ENewLongSteelOrdersRoutes.UPDATE}`}
        component={OrderUpdate}
      />

      <Route
        path={`${path}${ENewLongSteelOrdersRoutes.DETAILS}/:orderId${ENewLongSteelOrdersRoutes.UPDATE}`}
        component={OrderUpdate}
      />

      <OrderCancel />
      <OrderDownload />

      <UpateItemsUnavailable
        items={ordersState.updateItems.itemsSelected.filter(
          (item) => !item.changeAllowed
        )}
        itemsAllowedLength={ordersState.updateItems.itemsAllowed.length}
        type="update"
      />

      <LoadingModal
        enabled={loadingState}
        title="Aguarde alguns instantes"
        message={loadMessage()}
      />
    </>
  );
};
